import { render, staticRenderFns } from "./detail-base-info.vue?vue&type=template&id=8ffd778a&scoped=true&"
import script from "./detail-base-info.vue?vue&type=script&lang=js&"
export * from "./detail-base-info.vue?vue&type=script&lang=js&"
import style0 from "./detail-base-info.vue?vue&type=style&index=0&id=8ffd778a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd778a",
  null
  
)

export default component.exports